import Vue from 'vue'
import { Button, Tabs, LocaleProvider, Modal, message } from 'ant-design-vue'
import passengerSegList from '@/components/passenger-seg-list-new'
import '@/assets/css/l8-model.less'
Vue.config.productionTip = false

Vue.use(Button)
Vue.use(Tabs)
Vue.use(LocaleProvider)
Vue.use(passengerSegList)
Vue.use(Modal)
Vue.prototype.$message = message
Vue.prototype.$error = Modal.error
